export function enableZoom(svgId) {
    const svg = document.getElementById(svgId);
    const viewBox = svg.viewBox.baseVal;

  let isPanning = false;
  let start = { x: 0, y: 0 };
  let targetViewBox = { x: viewBox.x, y: viewBox.y, width: viewBox.width, height: viewBox.height };

  function animate() {
    const easing = 0.1;

    viewBox.x += (targetViewBox.x - viewBox.x) * easing;
    viewBox.y += (targetViewBox.y - viewBox.y) * easing;
    viewBox.width += (targetViewBox.width - viewBox.width) * easing;
    viewBox.height += (targetViewBox.height - viewBox.height) * easing;

    requestAnimationFrame(animate);
  }

  animate(); // start animation loop

  // PAN
  svg.addEventListener('mousedown', (e) => {
    isPanning = true;
    start = { x: e.clientX, y: e.clientY };
  });

  svg.addEventListener('mousemove', (e) => {
    if (!isPanning) return;

    const dx = (e.clientX - start.x) * viewBox.width / svg.clientWidth;
    const dy = (e.clientY - start.y) * viewBox.height / svg.clientHeight;

    targetViewBox.x -= dx;
    targetViewBox.y -= dy;

    start = { x: e.clientX, y: e.clientY };
  });

  svg.addEventListener('mouseup', () => isPanning = false);
  svg.addEventListener('mouseleave', () => isPanning = false);

  // ZOOM
  svg.addEventListener('wheel', (e) => {
    e.preventDefault();

    const scaleFactor = 1.2;
    const zoomAmount = e.deltaY < 0 ? 1 / scaleFactor : scaleFactor;

    const rect = svg.getBoundingClientRect();
    const mx = e.clientX - rect.left;
    const my = e.clientY - rect.top;

    const zoomX = mx / svg.clientWidth;
    const zoomY = my / svg.clientHeight;

    const newWidth = targetViewBox.width * zoomAmount;
    const newHeight = targetViewBox.height * zoomAmount;

    targetViewBox.x += (targetViewBox.width - newWidth) * zoomX;
    targetViewBox.y += (targetViewBox.height - newHeight) * zoomY;
    targetViewBox.width = newWidth;
    targetViewBox.height = newHeight;
  }, { passive: false });
    
    
//     const viewBox = svg.viewBox.baseVal;

//   let isPanning = false;
//   let start = { x: 0, y: 0 };

//   // PAN
//   svg.addEventListener('mousedown', (e) => {
//     isPanning = true;
//     start = { x: e.clientX, y: e.clientY };
//   });

//   svg.addEventListener('mousemove', (e) => {
//     if (!isPanning) return;
//     const dx = (e.clientX - start.x) * viewBox.width / svg.clientWidth;
//     const dy = (e.clientY - start.y) * viewBox.height / svg.clientHeight;
//     viewBox.x -= dx;
//     viewBox.y -= dy;
//     start = { x: e.clientX, y: e.clientY };
//   });

//   svg.addEventListener('mouseup', () => isPanning = false);
//   svg.addEventListener('mouseleave', () => isPanning = false);

//   // ZOOM
//   svg.addEventListener('wheel', (e) => {
//     e.preventDefault();

//     const scaleFactor = 1.1;
//     const { width, height, x, y } = viewBox;

//     // Mouse position relative to SVG
//     const rect = svg.getBoundingClientRect();
//     const mx = e.clientX - rect.left;
//     const my = e.clientY - rect.top;

//     const zoomX = mx / svg.clientWidth;
//     const zoomY = my / svg.clientHeight;

//     const zoomAmount = e.deltaY < 0 ? 1 / scaleFactor : scaleFactor;

//     const newWidth = width * zoomAmount;
//     const newHeight = height * zoomAmount;

//     viewBox.x += (width - newWidth) * zoomX;
//     viewBox.y += (height - newHeight) * zoomY;
//     viewBox.width = newWidth;
//     viewBox.height = newHeight;
//   }, { passive: false });
    
    
    
    
    // let viewBox = { x: 0, y: 0, width: 1009, height: 665 };//1009.6727 665.96301
    // let targetViewBox = { ...viewBox };
    // const zoomFactor = 1.2;
    // let isZooming = false;

    // svg.addEventListener('wheel', (e) => {
    //   e.preventDefault();

    //   const svgRect = svg.getBoundingClientRect();
    //   const mouseX = e.offsetX / svgRect.width;
    //   const mouseY = e.offsetY / svgRect.height;

    //   const zoomIn = e.deltaY < 0;
    //   const scale = zoomIn ? (1 / zoomFactor) : zoomFactor;

    //   const newWidth = viewBox.width * scale;
    //   const newHeight = viewBox.height * scale;

    //   const newX = viewBox.x + (viewBox.width - newWidth) * mouseX;
    //   const newY = viewBox.y + (viewBox.height - newHeight) * mouseY;

    //   targetViewBox = { x: newX, y: newY, width: newWidth, height: newHeight };

    //   if (!isZooming) animateZoom();
    // });

    // function animateZoom() {
    //   isZooming = true;

    //   const lerp = (start, end, t) => start + (end - start) * t;
    //   const threshold = 0.5;

    //   function step() {
    //     viewBox.x = lerp(viewBox.x, targetViewBox.x, 0.2);
    //     viewBox.y = lerp(viewBox.y, targetViewBox.y, 0.2);
    //     viewBox.width = lerp(viewBox.width, targetViewBox.width, 0.2);
    //     viewBox.height = lerp(viewBox.height, targetViewBox.height, 0.2);

    //     svg.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`);

    //     const dx = Math.abs(viewBox.x - targetViewBox.x);
    //     const dy = Math.abs(viewBox.y - targetViewBox.y);
    //     const dw = Math.abs(viewBox.width - targetViewBox.width);
    //     const dh = Math.abs(viewBox.height - targetViewBox.height);

    //     if (dx > threshold || dy > threshold || dw > threshold || dh > threshold) {
    //       requestAnimationFrame(step);
    //     } else {
    //       viewBox = { ...targetViewBox };
    //       svg.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`);
    //       isZooming = false;
    //     }
    //   }

    //   requestAnimationFrame(step);
    // }
}